<div class="box-form-ui container">
  <h2 class="professional-account-package-title">
    <strong>{{ name }}, continúa con la apertura de tu CDT</strong>
    completando estos datos
  </h2>

  <form
    id="PersonalInformationForm"
    class="personal-information-form"
    [formGroup]="personalInformationForm"
    (ngSubmit)="onSubmit()"
  >
    <p>Fecha de nacimiento</p>
    <div formGroupName="dateGroup" class="date-picker-container">
      <div class="date-wrapper">
        <mat-form-field class="day-input">
          <mat-label class="label">Día</mat-label>
          <input
            matInput
            appDayLimit
            appOnlyNumbers
            type="tel"
            inputmode="numeric"
            formControlName="day"
            maxlength="2"
            id="BirthDay"
            [errorStateMatcher]="confirmValidMatcher"
          />
        </mat-form-field>
        <mat-form-field class="month-input">
          <mat-label class="label">Mes</mat-label>
          <mat-select
            appSelectOverlayPosition
            disableOptionCentering
            formControlName="month"
            [errorStateMatcher]="confirmValidMatcher"
          >
            <mat-option *ngFor="let month of months" [value]="month.value">
              {{ month.viewValue }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="year-input">
          <mat-label class="label">Año</mat-label>
          <input
            matInput
            appOnlyNumbers
            appNotStartZero
            type="tel"
            inputmode="numeric"
            formControlName="year"
            maxlength="4"
            [errorStateMatcher]="confirmValidMatcher"
            id="BirthYear"
          />
        </mat-form-field>
      </div>
      <div class="date-errors">
        <mat-error
          *ngIf="
            (personalInformationForm
              .get('dateGroup.day')!
              .hasError('required') ||
              personalInformationForm
                .get('dateGroup.month')!
                .hasError('required') ||
              personalInformationForm
                .get('dateGroup.year')!
                .hasError('required')) &&
            personalInformationForm.get('dateGroup')!.touched
          "
        >
          La fecha es obligatoria.
        </mat-error>
        <mat-error
          *ngIf="
            !(
              personalInformationForm
                .get('dateGroup.day')!
                .hasError('required') ||
              personalInformationForm
                .get('dateGroup.month')!
                .hasError('required') ||
              personalInformationForm
                .get('dateGroup.year')!
                .hasError('required')
            ) &&
            !personalInformationForm.controls['dateGroup'].hasError(
              'monthsDayFirstError'
            ) &&
            !personalInformationForm.controls['dateGroup'].hasError(
              'leapYear'
            ) &&
            !personalInformationForm.controls['dateGroup'].hasError(
              'monthsDaySecondError'
            ) &&
            personalInformationForm.get('dateGroup.year')!.hasError('yearError')
          "
        >
          Ingresa una fecha válida.
        </mat-error>
        <mat-error
          *ngIf="
            personalInformationForm.controls['dateGroup'].hasError('leapYear')
          "
        >
          Este mes tiene 29 días, ingresa una fecha válida.
        </mat-error>
        <mat-error
          *ngIf="
            personalInformationForm.controls['dateGroup'].hasError(
              'monthsDayFirstError'
            )
          "
        >
          Este mes tiene 28 días, ingresa una fecha válida.
        </mat-error>
        <mat-error
          *ngIf="
            personalInformationForm.controls['dateGroup'].hasError(
              'monthsDaySecondError'
            )
          "
        >
          Este mes tiene 30 días, ingresa una fecha válida.
        </mat-error>
        <mat-error
          *ngIf="
            !personalInformationForm
              .get('dateGroup.year')!
              .hasError('yearError') &&
            !personalInformationForm.controls['dateGroup'].hasError(
              'monthsDayFirstError'
            ) &&
            !personalInformationForm.controls['dateGroup'].hasError(
              'leapYear'
            ) &&
            !personalInformationForm.controls['dateGroup'].hasError(
              'monthsDaySecondError'
            ) &&
            personalInformationForm.controls['dateGroup'].hasError('rateAge')
          "
        >
          Ingresa una fecha válida.
        </mat-error>
        <mat-error
          *ngIf="
            !personalInformationForm
              .get('dateGroup.year')!
              .hasError('yearError') &&
            !personalInformationForm.controls['dateGroup'].hasError(
              'monthsDayFirstError'
            ) &&
            !personalInformationForm.controls['dateGroup'].hasError(
              'leapYear'
            ) &&
            !personalInformationForm.controls['dateGroup'].hasError(
              'monthsDaySecondError'
            ) &&
            !personalInformationForm.controls['dateGroup'].hasError(
              'rateAge'
            ) &&
            personalInformationForm.controls['dateGroup'].hasError(
              'expeditionDateValidationError'
            )
          "
        >
          Ingresa una fecha válida.
        </mat-error>
        <mat-error
          *ngIf="
            !personalInformationForm.controls['dateGroup'].hasError(
              'monthsDayFirstError'
            ) &&
            !personalInformationForm.controls['dateGroup'].hasError(
              'leapYear'
            ) &&
            !personalInformationForm.controls['dateGroup'].hasError(
              'monthsDaySecondError'
            ) &&
            personalInformationForm.controls['dateGroup'].hasError('futureDate')
          "
        >
          Una fecha actual o futura no es válida.
        </mat-error>
      </div>
    </div>

    <mat-form-field>
      <mat-label class="label"> Ciudad donde naciste </mat-label>
      <input
        matInput
        formControlName="birthCity"
        autocomplete="off"
        id="BirthCity"
        [matAutocomplete]="birthCityAuto"
      />
      <mat-autocomplete
        #birthCityAuto="matAutocomplete"
        [displayWith]="displayFn"
        (closed)="closedEmitter('birthCity')"
      >
        <mat-option
          *ngFor="let option of filteredBirthCityOptions | async"
          [value]="option"
        >
          {{ option.municipality }}
        </mat-option>
      </mat-autocomplete>
      <mat-error
        *ngIf="
          personalInformationForm.controls['birthCity'].hasError('required')
        "
      >
        Este campo es obligatorio
      </mat-error>
      <mat-error
        *ngIf="
          !personalInformationForm.controls['birthCity'].hasError('required') &&
          personalInformationForm.controls['birthCity'].hasError('isString')
        "
      >
        La ciudad que ingresaste no es válida
      </mat-error>
    </mat-form-field>

    <p>Género</p>
    <mat-radio-group class="gender-group" formControlName="genderInputGroup">
      <mat-radio-button value="M">Masculino</mat-radio-button>
      <mat-radio-button value="F">Femenino</mat-radio-button>
    </mat-radio-group>

    <div class="box-btn-submit">
      <button
        class="btn btn-degraded blue"
        type="submit"
        [disabled]="!personalInformationForm.valid"
        id="PersonalInformationSubmitButton"
      >
        Continuar
      </button>
    </div>
  </form>
</div>
